import { useCallback, useEffect, useMemo, useState } from 'react';
import { get } from 'lodash';

const nextDirection = {
  asc: 'desc',
  desc: 'none',
  none: 'asc',
} as const;

export function useSort<T>(rows: T[]) {
  const [sortedRows, setSortedRows] = useState(rows || []);
  const [direction, setDirection] = useState<'asc' | 'desc' | 'none'>('none');
  const [field, setField] = useState();

  const onClickSort = useCallback(
    (cField) => {
      setField(cField);
      if (cField === field) {
        setDirection(nextDirection[direction]);
      } else {
        setDirection('asc');
      }
    },
    [field, direction, rows],
  );

  useEffect(() => {
    if (!direction) {
      setSortedRows(rows);
    }
    let sort = [...rows];
    if (field) {
      sort = sort.sort((aRow, bRow) => {
        let a = get(aRow, field);
        a = typeof a === 'string' ? a.toLowerCase() : a;
        let b = get(bRow, field);
        b = typeof b === 'string' ? b.toLowerCase() : b;
        if (a < b) return direction === 'asc' ? -1 : 1;
        if (a > b) return direction === 'asc' ? 1 : -1;
        return 0;
      });
    }
    setSortedRows(sort);
  }, [direction, field, rows]);

  return useMemo(() => {
    return { sortedRows, onClickSort, direction, sortField: field };
  }, [sortedRows, onClickSort, direction, field, rows]);
}
